import React from "react";

import Upload from "../../components/UI/Upload/Upload";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import { Form, Row, Col, Button } from "react-bootstrap";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import InputComponent from "../../components/UI/InputComponent/InputComponent";
import Select from "react-virtualized-select";
import "./formBuilderHelper.css";
import { CloseOutlined, PaperClipOutlined } from "@ant-design/icons";
import DatepickerComponent from "../../components/UI/DatePicker/DatepickerComponent";
import UploadComponent from "../../components/UI/Upload/UploadComponent";
import { Checkbox } from "antd";

const formBuilderHelper = (
  parentState,
  userInputHandler,
  uploadHandler,
  clearForm,
  hideModal,
  downloadAttachments,
  handleDayClick,
  dropdownHandler,
  autocompleteCountryHandler,
  autocompleteCityHandler,
  autocompleteDistrictHandler,
  userInputHandlerNumber,
  removeAttachment,
  openConfirmationModal,
  checkboxHandler,
  isLoading,
) => {
  let attachementLabels = [];
  let isOib;
  let secondaryOib;
  let newArray = [];
  let wrapper = [];
  let selectedFiles = parentState.selectedFiles && [
    ...parentState.selectedFiles,
  ];

  const selectStyle = { borderColor: "red" };

  //ADRESE

  const { countryList, cityAndMuncipalityList, districtList } = parentState;

  const requestType = [
    {
      formId: 1,
      formDescription: "REGISTAR OVLAŠTENIH REVIZORA",
    },
    { formId: 3, formDescription: "REGISTAR REVIZORSKIH DRUŠTAVA" },
    {
      formId: 4,
      formDescription: "REGISTAR SAMOSTALNIH REVIZORA",
    },
    {
      formId: 5,
      formDescription: "REGISTAR OVLAŠTENIH REVIZORA IZ DRUGIH DRŽAVA ČLANICA",
    },
    {
      formId: 6,
      formDescription: "REGISTAR REVIZORSKIH DRUŠTAVA IZ DRUGIH DRŽAVA ČLANICA",
    },
    {
      formId: 7,
      formDescription: "REGISTAR REVIZORA IZ TREĆE ZEMLJE",
    },
    {
      formId: 8,
      formDescription:
        "REGISTAR SUBJEKATA ZA OBAVLJANJE REVIZIJE U TREĆOJ ZEMLJI I REGISTAR REVIZORA U TREĆOJ ZEMLJI",
    },
    {
      formId: 10,
      formDescription: "REGISTAR REVIZORSKIH VJEŽBENIKA",
    },
  ];

  let statusOptions = requestType.map((element) => (
    <option key={element.formId} value={element.formId}>
      {element.formDescription}
    </option>
  ));

  let newState = { ...parentState.initialFormData };
  if (newState.groupList) {
    newState.groupList.map((element, index1) => {
      newArray = [];

      newArray.push(
        element.formGroupId == 2 ? (
          <div
            style={{
              padding: 4,
              width: "100%",
              backgroundColor: "#f8f9fa",
              marginBottom: "16px",
            }}
          >
            <p style={{ fontWeight: 500, margin: 0, padding: 0 }}>Prilozi</p>
            {!parentState.readOnly && <ul>

              <li>dopušteni formati: PDF, PNG, JPEG</li>
              <li>maksimalna veličina datoteke - 10MB</li>
            </ul>
            }
          </div>
        ) : null
      );


      element.controlList.map(async (el, index2) => {
        if (el.isVisible)
          switch (el.controlType) {
            case "text":
              if (el.controlLabel == "Opis") {
                newArray.push(
                  <div key={`opis${el.controlIndex}`}>
                    <InputComponent
                      required={el.required}
                      controlLabel={el.controlLabel}
                      style={
                        el.required &&
                        parentState.error &&
                        el.value.length < 1 &&
                        "red"
                      }
                      readOnly={parentState.readOnly || false}
                      value={el.value}
                      id={el.uuid}
                      onChange={(e) => userInputHandler(e, (isOib = false))}
                      rows="3"
                      as="textarea"
                    ></InputComponent>
                  </div>
                );
                break;
              }

              //ako postoji država stavi select

              if (el.controlLabel === "Naziv države") {
                let newCountryList;
                if (
                  (parentState.formId == 6 &&
                    (el.addressGroup == 1 || el.addressGroup == 2)) ||
                  (parentState.formId == 7 && el.addressGroup == 2)
                ) {
                  newCountryList = countryList.filter(
                    (element) => element.sifDrzave != 191
                  );
                } else {
                  newCountryList = countryList;
                }

                newArray.push(
                  <div key={el.controlIndex}>
                    <label style={{ width: "100%" }} className="select-label">
                      <span>{el.controlLabel}</span>
                      <Select
                        className="fbh_select"
                        style={
                          (el.required &&
                            parentState.error &&
                            el.value.length < 1 &&
                            selectStyle) ||
                          null
                        }
                        disabled={
                          parentState.readOnly
                          // ||
                          // (parentState.formId == 7 && el.addressGroup == 1)
                        }
                        // disabled={props.disableCountry}
                        noResultsText={"Nema rezultata"}
                        placeholder={
                          parentState.readOnly && el.value == ""
                            ? "Nije odabrano"
                            : "Odaberi državu"
                        }
                        options={newCountryList}
                        onChange={(selectValue) =>
                          autocompleteCountryHandler(selectValue, {
                            // formGroup: "address",
                            id: "Naziv države",
                            addressGroup: el.addressGroup,
                            // name: "nazivDrzave"
                          })
                        }
                        labelKey="nazivKratki"
                        valueKey="sifDrzave"
                        value={el.value}
                      />
                    </label>
                  </div>
                );

                break;
              }

              //ako postoji naziv grada i država ima odabranu vrijednost 191-iz sifarnika
              if (el.controlLabel === "Naziv grada" && el.addressGroup == 1) {
                const findControlGroup = element.controlList.find(
                  (address) =>
                    address.addressGroup === el.addressGroup &&
                    address.controlLabel === "Naziv države"
                );
                const countryValue = findControlGroup.value;

                if (countryValue != 191 && countryValue != "") {
                  newArray.push(
                    <div key={el.controlIndex}>
                      <InputComponent
                        disabled={countryValue.length < 1}
                        required={el.required}
                        controlLabel={el.controlLabel}
                        style={
                          el.required &&
                          parentState.error &&
                          el.value.length < 1 &&
                          "red"
                        }
                        maxLength="55"
                        readOnly={parentState.readOnly || false}
                        value={el.value}
                        id={el.uuid}
                        onChange={(e) => userInputHandler(e, (isOib = false))}
                        type="text"
                      ></InputComponent>
                    </div>
                  );
                  break;
                } else if (countryValue == 191 || countryValue === "") {
                  newArray.push(
                    <div key={el.controlIndex}>
                      <label style={{ width: "100%" }} className="select-label">
                        <span>
                          {" "}
                          {el.required
                            ? `${el.controlLabel}*`
                            : el.controlLabel}{" "}
                        </span>
                        <Select
                          className="fbh_select"
                          style={
                            (el.required &&
                              parentState.error &&
                              el.value.length < 1 &&
                              selectStyle) ||
                            null
                          }
                          disabled={
                            countryValue.length < 1 || parentState.readOnly
                          }
                          noResultsText={"Nema rezultata"}
                          placeholder={
                            parentState.readOnly && el.value == ""
                              ? "Nije odabrano"
                              : "Odaberi grad"
                          }
                          options={cityAndMuncipalityList}
                          onChange={(selectValue) =>
                            autocompleteCityHandler(selectValue, {
                              id: "Naziv grada",
                              addressGroup: el.addressGroup,
                            })
                          }
                          labelKey="nazGrdOpc"
                          valueKey="sifGrdOpc"
                          value={el.value}
                        />
                      </label>
                    </div>
                  );
                  break;
                }
              }

              //ako postoji polje naselje i država ima odabranu vrijednost 191 iz šifarnika, disejblaj ako postoji grad i polje nije odabrano!!!!
              if (el.controlLabel === "Naziv mjesta") {
                let districtListUpdated = [...districtList];

                const findControlGroup = element.controlList.find(
                  (address) =>
                    address.addressGroup === el.addressGroup &&
                    address.controlLabel === "Naziv države"
                );
                const countryValue = findControlGroup.value;
                const cityExists = element.controlList.find(
                  (cityAdr) =>
                    cityAdr.addressGroup === el.addressGroup &&
                    cityAdr.controlLabel === "Naziv grada"
                );

                if (
                  cityExists &&
                  cityExists.value !== "" &&
                  countryValue == "191"
                ) {
                  districtListUpdated = [...districtList].filter((element) => {
                    return element.sifGrdOpc == cityExists.value;
                  });
                }
                if (countryValue != 191) {
                  newArray.push(
                    <div key={el.controlIndex}>
                      <InputComponent
                        // disabled={countryValue.length < 1}
                        required={el.required}
                        controlLabel={el.controlLabel}
                        style={
                          el.required &&
                          parentState.error &&
                          el.value.length < 1 &&
                          "red"
                        }
                        maxLength="55"
                        readOnly={parentState.readOnly || false}
                        value={el.value}
                        id={el.uuid}
                        onChange={(e) => userInputHandler(e, (isOib = false))}
                        type="text"
                      ></InputComponent>
                    </div>
                  );
                  break;
                } else if (countryValue == 191) {
                  newArray.push(
                    <div key={el.controlIndex}>
                      <label style={{ width: "100%" }} className="select-label">
                        <span>{`${el.controlLabel}`}</span>
                        <Select
                          className="fbh_select"
                          style={
                            (el.required &&
                              parentState.error &&
                              el.value.length < 1 &&
                              selectStyle) ||
                            null
                          }
                          disabled={parentState.readOnly}
                          // disabled={countryValue.length < 1}
                          noResultsText={"Nema rezultata"}
                          placeholder={
                            parentState.readOnly && el.value == ""
                              ? "Nije odabrano"
                              : "Odaberi mjesto"
                          }
                          options={districtListUpdated}
                          onChange={(selectValue) =>
                            autocompleteDistrictHandler(selectValue, {
                              id: "Naziv mjesta",
                              addressGroup: el.addressGroup,
                            })
                          }
                          labelKey="nazNaselja"
                          valueKey="sifNaselja"
                          value={el.value}
                        />
                      </label>
                    </div>
                  );
                  break;
                }
              }

              newArray.push(
                <div key={el.controlIndex}>
                  <InputComponent
                    required={el.required}
                    controlLabel={el.controlLabel}
                    style={
                      el.required &&
                      parentState.error &&
                      el.value.length < 1 &&
                      "red"
                    }
                    readOnly={parentState.readOnly || false}
                    value={el.value}
                    id={el.uuid}
                    onChange={(e) => userInputHandler(e, (isOib = false))}
                    type="text"
                  ></InputComponent>
                </div>
              );
              break;

            case "mbs":
              newArray.push(
                <div key={el.controlIndex}>
                  <InputComponent
                    style={
                      el.required &&
                      parentState.error &&
                      el.value.length < 1 &&
                      "red"
                    }
                    controlLabel={el.controlLabel}
                    minLength="9"
                    maxLength="9"
                    readOnly={parentState.readOnly || false}
                    required={el.required}
                    value={el.value}
                    id={el.uuid}
                    onChange={(e) => userInputHandlerNumber(e, (isOib = false))}
                    type="text"
                  ></InputComponent>
                </div>
              );
              break;
            case "checkbox":
              newArray.push(
                <div key={`checkbox${el.controlIndex}`}>
                  <Checkbox
                    id={el.uuid}
                    checked={parentState.readOnly ? true : el.value}
                    disabled={parentState.readOnly ? true : false}
                    onChange={checkboxHandler}
                  >
                    {el.controlLabel}
                  </Checkbox>
                </div>
              );
              break;
            case "upload":
              const labels = {
                controlLabel: el.controlLabel,
                controlIndex: el.controlIndex,
              };
              parentState.attachments && attachementLabels.push(labels);

              let fileUpload = parentState.selectedFiles &&
                !parentState.update && (
                  <div className="div_label_i_dokument" key={el.controlIndex}>
                    <Form.Label>
                      &bull; {el.controlLabel}
                      {el.required && "*"}
                    </Form.Label>

                    <div className="unos_upload">
                      <UploadComponent
                        id={String(el.controlIndex)}
                        onChange={uploadHandler}
                        accept="application/pdf,image/x-png,image/jpeg"
                        fileList={selectedFiles}
                      />
                    </div>
                  </div>
                );

              let files = fileUpload;
              newArray.push(files);

              break;

            case "date":
              const readOnlyDate = (
                <div key={el.controlIndex}>
                  <InputComponent
                    controlLabel={el.controlLabel}
                    maxLength="55"
                    readOnly={parentState.readOnly || false}
                    value={el.value}
                    id={el.uuid}
                    type="text"
                  />
                </div>
              );

              const date = (
                <div key={el.controlIndex} className="dp_formBuilderHelper">
                  <DatepickerComponent
                    id={String(el.controlIndex)}
                    required={el.required}
                    controlLabel={el.controlLabel}
                    errorBorderColor={
                      el.required &&
                      parentState.error &&
                      el.value.length < 1 &&
                      "red"
                    }
                    value={el.value}
                    width={"100%"}
                    index={el.controlIndex}
                    handleDayClick={handleDayClick}
                  ></DatepickerComponent>
                </div>
              );

              newArray.push(
                <div key={`date${el.controlIndex}`}>
                  {parentState.readOnly ? readOnlyDate : date}
                </div>
              );
              break;

            case "oib":
              newArray.push(
                <div key={el.controlIndex}>
                  <InputComponent
                    disabled={parentState.update}
                    maxLength="11"
                    minLength="11"
                    controlLabel={el.controlLabel}
                    required={el.required}
                    style={
                      el.required &&
                      parentState.error &&
                      el.value.length < 1 &&
                      "red"
                    }
                    readOnly={parentState.readOnly || false}
                    onChange={(e) =>
                      userInputHandler(
                        e,
                        (isOib = true),
                        (secondaryOib = el.required ? false : true)
                      )
                    }
                    value={el.value}
                    min="0"
                    id={el.uuid}
                  ></InputComponent>
                  {!el.required &&
                    parentState.secondaryOib.value.length > 0 &&
                    parentState.secondaryOib.invalidOib && (
                      <p style={{ color: "red" }}>Oib nije ispravan!</p>
                    )}
                  {el.required &&
                    parentState.invalidOib &&
                    el.value.length <= 11 && (
                      <p style={{ color: "red" }}>Oib nije ispravan!</p>
                    )}
                </div>
              );
              break;
            //našao sam teeeeeeeeeeee
            case "label":
              // ako nema priloga na pregledu, samo ritrnaj
              if (
                parentState.attachments &&
                parentState.attachments.length < 1 &&
                parentState.readOnly
              ) {
                // newArray.push(
                //   <p style={{ fontStyle: "italic" }}>Nema učitanih priloga</p>
                // );
                break;
              }

              newArray.push(
                <div key={el.controlIndex}>
                  <Form.Label style={{ marginBottom: "10px" }}>
                    <i>{el.controlLabel}</i>
                  </Form.Label>
                </div>
              );
              break;

            case "dropdown":
              newArray.push(
                <div key={el.controlIndex}>
                  <Dropdown
                    required={el.required}
                    style={
                      el.required &&
                      parentState.error &&
                      el.value.length < 1 &&
                      "red"
                    }
                    id={el.uuid}
                    readOnly={parentState.readOnly || false}
                    onChange={dropdownHandler}
                    asProperty="select"
                    map={statusOptions}
                    label="Vrsta registra"
                    text="Vrsta registra*"
                    value={el.value}
                    hidden
                  />
                </div>
              );
              break;

            case "mail":
              newArray.push(
                <div key={el.controlIndex}>
                  <InputComponent
                    controlLabel={el.controlLabel}
                    style={
                      (el.required &&
                        parentState.error &&
                        el.value.length < 1 &&
                        "red") ||
                      (!parentState.readOnly && el.value.length > 0 &&
                        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                          el.value
                        ) &&
                        "red")
                    }
                    required={el.required}
                    readOnly={parentState.readOnly || false}
                    id={el.uuid}
                    value={el.value}
                    onChange={(e) => userInputHandler(e, (isOib = false))}
                    type="email"
                  ></InputComponent>
                </div>
              );
              break;

            case "number":
              newArray.push(
                <div key={el.controlIndex}>
                  <InputComponent
                    controlLabel={el.controlLabel}
                    style={
                      el.required &&
                      parentState.error &&
                      el.value.length < 1 &&
                      "red"
                    }
                    min="0"
                    required={el.required}
                    readOnly={parentState.readOnly || false}
                    value={el.value}
                    id={el.uuid}
                    onChange={(e) => userInputHandlerNumber(e, (isOib = false))}
                  ></InputComponent>
                </div>
              );
              break;

            default:
              break;
          }
      });

      //ovo tu
      wrapper.push(
        <div key={`form-group${index1}`}>
          <Form.Group
            key={`form-group${index1}`}
            style={{ marginBottom: "40px" }}
          >
            {/* <h5 style={{ marginBottom: "16px", fontWeight: 600 }}>
              {element.description}
            </h5> */}
            {newArray}
          </Form.Group>
        </div>
      );
    });

    //ovo gledaj

    let updateAttachments =
      parentState.update &&
      attachementLabels.map((formElement, index) => {
        const findLabel = parentState.attachments.find(
          (element) => element.controlIndex == formElement.controlIndex
        );

        const findIndexOfAttachment = parentState.attachments.findIndex(
          (element) => element.controlIndex == formElement.controlIndex
        );

        return findLabel ? (
          <div key={findLabel.controlIndex} className="div_label_i_dokument">
            <Form.Label id={index} className="div_label">
              {formElement.controlLabel}
            </Form.Label>

            <div className="div_dokument">
              {/* div za ikonu i tekst -download */}
              <div
                className="div_ikona_tekst"
                onClick={(e) =>
                  downloadAttachments(
                    e,
                    findIndexOfAttachment,
                    findLabel.contentType,
                    findLabel.fileName
                  )
                }
              >
                <PaperClipOutlined
                  style={{ marginRight: "8px", color: "#464646" }}
                />
                {findLabel.fileName}
              </div>
              {/* div za x */}
              <div
                className="iksic"
                onClick={removeAttachment(formElement.controlIndex)}
              >
                <CloseOutlined />
              </div>
            </div>
          </div>
        ) : (
          <div key={formElement.controlIndex} className="div_label_i_dokument">
            <Form.Label>
              &bull; {formElement.controlLabel}
              {formElement.required && "*"}
            </Form.Label>
            <UploadComponent
              id={String(formElement.controlIndex)}
              onChange={uploadHandler}
              accept="application/pdf,image/x-png,image/jpeg"
              fileList={selectedFiles}
            />
          </div>
        );
      });

    updateAttachments && parentState.update && newArray.push(updateAttachments);

    let attachmentsDetected =
      parentState.attachments &&
      !parentState.update &&
      parentState.attachments.map((formElement, index) => {
        const findLabel = attachementLabels.find(
          (element) => element.controlIndex == formElement.controlIndex
        );

        if (findLabel) {
          return (
            <div key={`attachment-${index}`} className="div_label_i_dokument">
              <Form.Label id={index} className="div_label">
                {findLabel.controlLabel}
              </Form.Label>
              <div className="div_dokument">
                <div
                  className="div_ikona_tekst"
                  onClick={(e) =>
                    downloadAttachments(
                      e,
                      index,
                      formElement.contentType,
                      formElement.fileName
                    )
                  }
                >
                  <PaperClipOutlined
                    style={{ marginRight: "8px", color: "#464646" }}
                  />
                  {formElement.fileName}
                </div>
              </div>
            </div>
          );
        }
      });

    attachmentsDetected && newArray.push(attachmentsDetected);
    const noAttachmentsUploaded =
      parentState.attachments && parentState.attachments.length > 0;
    !noAttachmentsUploaded &&
      parentState.readOnly &&
      newArray.push(
        <p key={`no-items-uploaded`} style={{ fontStyle: "italic" }}>
          Nema učitanih priloga!
        </p>
      );
    //TODO: reafactorati
    let readOnlyButtons =
      (parentState.readOnly && parentState.initialFormData.status !== 1 && (
        <div className="row" key={"button"}>
          <div className="col-md-12">
            <ButtonComponent block onClick={hideModal} variant="danger">
              Zatvori
            </ButtonComponent>
          </div>
        </div>
      )) ||
      (parentState.readOnly && parentState.overview && (
        <div className="row" key={"button"}>
          <div className="col-md-12">
            <ButtonComponent block onClick={hideModal} variant="danger">
              Zatvori
            </ButtonComponent>
          </div>
        </div>
      )) ||
      (parentState.readOnly && (
        <div className="row" key={"button"}>
          <div className="col-md-6">
            <ButtonComponent type="submit" block>
              Obradi zahtjev
            </ButtonComponent>
          </div>
          <div className="col-md-6">
            <ButtonComponent block onClick={hideModal} variant="danger">
              Zatvori
            </ButtonComponent>
          </div>
        </div>
      )) ||
      (parentState.update && (
        <div className="row" key={"button"}>
          <div className="col-md-6">
            <ButtonComponent 
            type="submit" 
            variant="primary" 
            block
            loading={isLoading}
            >
              Ažuriraj zahtjev
            </ButtonComponent>
          </div>
          <div className="col-md-6">
            <ButtonComponent
              block
              onClick={openConfirmationModal}
              variant="danger"
              disabled={isLoading}
            >
              Zatvori
            </ButtonComponent>
          </div>
        </div>
      ));

    let inputFormLabel = (
      <div key="required-fields" className="row">
        <div className="col">
          <p style={{ fontWeight: 500 }}>
            Polja označena zvjezdicom (*) su obavezna{" "}
          </p>
        </div>
      </div>
    );

    let addButtons = readOnlyButtons || inputFormLabel;
    wrapper.push(addButtons);
  }

  return wrapper;
};

export default formBuilderHelper;
